<template>
  <div class="order-list">
    <el-card class="query-card">

      <el-form
          :model="quickReqVo"
          :rules="rules"
          ref="quickReqVo"
          label-width="200px"
          size="small"
      >

        <!-- 交易金额 -->
        <el-form-item :label="$t('toGetPayLinks.amount')" prop="vtAmount">
          <el-input
              v-model="quickReqVo.vtAmount"

              clearable
              style="width: 430px"
          />
        </el-form-item>

        <!-- 请选择币种 -->
        <el-form-item :label="$t('toGetPayLinks.currency')" prop="vtCurrency">
          <el-select v-model="quickReqVo.vtCurrency" :placeholder="$t('toGetPayLinks.currency')" style="width: 430px">
            <el-option
                v-for="item in currencyList"
                :key="item.currName"
                :label="item.currName"
                :value="item.currName"
            />
          </el-select>
        </el-form-item>

        <!-- 请选择网关接入号 -->
        <el-form-item :label="$t('toGetPayLinks.gwNo')" prop="gatewayNo">
          <el-select v-model="quickReqVo.gatewayNo" :placeholder="$t('toGetPayLinks.gwNo')" style="width: 430px">
            <el-option
                v-for="item in gwoList"
                :key="item.gwno"
                :label="item.gwNo1"
                :value="item.gwno"
            />
          </el-select>
        </el-form-item>


        <!-- 按钮 -->
        <el-form-item>
          <el-button
              type="primary"
              @click="submitTradeInfo"
          >
<!--           获取支付链接-->
            {{this.$t('toGetPayLinks.getpayurl')}}
          </el-button>

        </el-form-item>

      </el-form>

    </el-card>



    <el-dialog
        :title="$t('toGetPayLinks.payurl')"
        :visible.sync="payDialogVisible"
        width="700px"
        :close-on-click-modal="false"
        :close-on-press-escape="false">

      <el-input
          v-model="payUrl"
          readonly>
      </el-input>

      <div style="margin-top:15px;text-align:right;">
        <el-button
            type="primary"
            @click="copyPayUrl">
<!--          复制链接-->
          {{this.$t('toGetPayLinks.copyData')}}
        </el-button>

      </div>

    </el-dialog>


  </div>
</template>

<script>

export default {
  name: "OrderList",
  data() {
    return {
      loading: false,
      refundIsCheck: null,
      quickReqVo: {
        merNo:"0",
        vtAmount: '',
        vtCurrency:"",
        gatewayNo:""
      },
      currencyList: [],
      gwoList: [],
      payDialogVisible:false,
      payUrl:"",
      orderInfo: null,

      loadingOrder: false,
      tableData: [],

      columnWidths:{},
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",

    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    //this.setDefaultTime(); //时间设置
    this.querOnSupport();
    this.getPayLinks();
  },
  mounted() {

  },
  // 发送变化重新计算
  computed:{
    rules() {
      return {
        vtAmount: [
          { required: true, message:this.$t('toGetPayLinks.noAmount'), trigger: 'blur' },
          {
            pattern: /^(?!0+(\.0+)?$)\d{1,16}(\.\d+)?$/,
            message: this.$t('toGetPayLinks.verifyAmount'),
            trigger: 'blur'
          }
        ],
        vtCurrency: [
          { required: true, message: this.$t('toGetPayLinks.quickInfo'), trigger: 'change' }
        ],
        gatewayNo: [
          { required: true, message: this.$t('toGetPayLinks.verifyGwNo'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    async querOnSupport(){
      try {
        const res = await this.$axios.post('/api/traderecord/onSupport')
        if(res.data.code === 0){
          this.currencyList = res.data.data || []

          if (!this.quickReqVo.vtCurrency && this.currencyList.length > 0) {
            const usdItem = this.currencyList.find(item => item.currName === 'USD')
            this.quickReqVo.vtCurrency = usdItem
                ? usdItem.currName
                : this.currencyList[0].currName
          }
        }
        // 如果币种为空需要弹出提示
        if(!this.currencyList || this.currencyList.length === 0){
          this.$message.error(this.$t('toGetPayLinks.quickInfo'));
        }


      }catch (e){
        console.error('获取币种列表失败:', e)
      }
    },
    async getPayLinks(){
      try {
        const res = await this.$axios.post('/api/traderecord/getPayLinks')
        if(res.data.code === 0){
          this.gwoList = res.data.data || []

          if (this.gwoList.length > 0) {
            this.quickReqVo.merNo = this.gwoList[0].merNo
          }
        }


      }catch (e){
        console.error('获取网关号失败:', e)
      }
    },

    // 获取支付链接
    async submitTradeInfo() {
      try {
        await this.$refs.quickReqVo.validate();
      } catch (e) {
       // console.warn('表单校验未通过:', e);
        return;
      }

        const params = {
          merNo: this.quickReqVo.merNo || undefined,
          vtAmount: this.quickReqVo.vtAmount || undefined,
          vtCurrency: this.quickReqVo.vtCurrency || undefined,
          gatewayNo: this.quickReqVo.gatewayNo || undefined,

        }


        const res = await this.$axios.post(
            '/api/traderecord/getVtAndSendInfo',
            params
        )
        if (res.data.code === 0) {

          this.payUrl = res.data.data;
          this.payDialogVisible = true;

        } else {

          this.$message.error(res.data.msg)
        }


    },
    copyPayUrl() {
      const text = String(this.payUrl || '');

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(this.$t('toGetPayLinks.copySuccess'));
        }).catch(() => {
          this.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },


    fallbackCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message.success(this.$t('toGetPayLinks.copySuccess'));
      } catch (e) {
        this.$message.error(this.$t('toGetPayLinks.copyFail') || '复制失败，请手动复制');
      }
      document.body.removeChild(textarea);
    },


    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();
      this.hasSearched = false;
      //this.handleSearch();
    },

  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 120px;
  text-align: right;
}


/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

.drawer-form {
  padding-right: 20px;
}

/*侧边弹窗*/
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 15px 20px;

  border-top: 1px solid #ebeef5;
  background: #fff;

  text-align: right;
}
::v-deep .el-drawer__body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.drawer-form {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 80px;
}
.drawer-footer {
  flex-shrink: 0;
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
  background: #fff;
  text-align: right;
}




</style>



// WEBPACK FOOTER //
// src/view/quickPay/toGetPayLinks.vue